
export default function GRSelectReportDestinationDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  confirmDialog,
  ssDialogService,
  loaderService,
  reportsDataService,
  reportsSharedModelService,
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSelectReportDestinationChange = handleSelectReportDestinationChange;
  vm.handleSubmit = handleSubmit;

  _activate();

  function _activate() {
  }

  /** ********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSubmit() {
    if ($scope.srSelectReportDestinationForm.$valid) {
      _confirmUnpublish();
    }
  }

  function handleSelectReportDestinationChange() {
    angular.forEach(vm.destinations, (currentDestination) => {
      if (currentDestination.destinationId === parseInt(vm.reportInstance.destinationId, 10)) {
        vm.destinationName = currentDestination.destinationName;
      }
    });
  }

  /** ********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.selectReportDestinationDialog);
  }

  // Confirm publishing
  function _confirmUnpublish($event) {
    let message = `Unpublishing the report will transfer the report into the My Reports area of ${vm.destinationName} `;
    message += 'where it will only be visible to you. Are you sure you want to unpublish the report?';

    ssDialogService.dialogs.reports.confirmUnpublishDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Confirm Unpublish Report',
        message,
        handleYesClick: () => { _handleYesUnpublishDialog(); },
        handleNoClick: () => { _handleNoUnpublishDialog(); }
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.confirmUnpublishDialog);
  }

  function _handleNoUnpublishDialog() {
    _closeConfirmDialog();
  }

  function _handleYesUnpublishDialog() {
    loaderService.showViewLoader = true;
    return reportsSharedModelService
      .unpublishReportInstance(vm.reportInstance.reportId, vm.reportInstance.reportInstanceId, vm.reportInstance.destinationId) // eslint-disable-line max-len
      .then((success) => {
        loaderService.showViewLoader = false;
        if (success) {
          $rootScope.$broadcast(`reports.generatedReports.reportType.reportInstanceUnpublished`, vm.reportInstance); // eslint-disable-line max-len
          alerts.success(`The Report has been successfully unpublished and moved to My Reports in ${vm.destinationName}`); // eslint-disable-line max-len
          _closeConfirmDialog();
          _closeDialog();
        } else {
          alerts.error('Error occurred while unpublishing the Report.');
        }
      });
  }

  function _closeConfirmDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.confirmUnpublishDialog);
  }
}

GRSelectReportDestinationDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'confirmDialog',
  'ssDialogService',
  'loaderService',
  'reportsDataService',
  'reportsSharedModelService',
];
